module.exports = __webpack_public_path__ + "img/OTP Image.db56cdc7.svg";